/**
 * Reference-logos molecule
 */
(function($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    let $molecule,
        referenceLogos = [];

    function ready() {
        $molecule = $('.reference-logos');

        const observerOptions = {
            root: null, // relative to document viewport
            rootMargin: '200px', // margin around root. Values are similar to css property. Unitless values not allowed
            // threshold: 1.0 // visible amount of item shown in relation to root
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                // console.log('entry', entry);
                if(entry.isIntersecting) {
                    loadReferenceLogos(function() {
                        startAnimation();
                    });

                    // only run once
                    // observer.unobserve(entry.target);
                }

                // let $target = $(entry.target);
                // if(entry.isIntersecting) {
                //     observer.unobserve(entry.target);
                // }
            });
        }, observerOptions);

        $molecule.each((idx, elm) => observer.observe(elm));
    }

    function loadReferenceLogos(callback) {
        // only get them once
        if (referenceLogos.length > 0) {
            callback();
            return;
        }

        $.get(
            'api/customerlogo/list',
            { limit: 20, order: '-id' },
            function processReferences(data) {
                referenceLogos = data.rows;

                insertReferenceLogosIntoDOM();

                callback();
            }
        );
    }

    function insertReferenceLogosIntoDOM() {
        let countLogos = 0;
        for (let key in referenceLogos) {
            let rl = referenceLogos[key];

            // stop after a number of logos
            if (countLogos >= 10) break;

            // skip references with no logo
            if (!rl.logoImageUrl) continue;

            // create DOM element and insert into template
            let $img = $('<img alt="'+ rl.name +'" src="'+ rl.logoImageUrl +'" loading="lazy" width="112" height="24" />');
            $('.reference-logos__logos', $molecule).append($img);

            countLogos++;
        }


    }

    function startAnimation() {
        // console.log($molecule);

    }

})(jQuery, window);